import { render, staticRenderFns } from "./UniversitasTable.vue?vue&type=template&id=2f61623e&"
import script from "./UniversitasTable.vue?vue&type=script&lang=js&"
export * from "./UniversitasTable.vue?vue&type=script&lang=js&"
import style0 from "./UniversitasTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports